import debug from "debug";
const log = debug("desjti:ui:formatDate:normalizeDate");
export const normalizeDate = (date) => {
    const shouldFormatDate = typeof date === "string" && !date.includes("T");
    if (!shouldFormatDate) {
        return typeof date === "string" ? new Date(date) : date;
    }
    const oldTime = new Date(date);
    const offset = -oldTime.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const newTime = new Date(oldTime.getTime() - offset);
    log("normalizeDate", {
        valueObtained: date,
        valueDate: oldTime,
        normalizedValue: newTime,
        timezoneOffset: offset,
    });
    return newTime;
};
//# sourceMappingURL=normalizeDate.js.map